import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BulkMultiselectBoundTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-multiselect-bound-template-styled",
  },
)`
  display: flex;
  width: calc(100% + 48px);

  .bulk-multiselect-bound-template__access-control-wrapper {
    padding-inline-start: 8px;
    padding-top: 8px;
    min-width: 48px;
  }
`;
